import { render } from "./LegoHeader.vue?vue&type=template&id=7acd27ea"
import script from "./LegoHeader.vue?vue&type=script&lang=js"
export * from "./LegoHeader.vue?vue&type=script&lang=js"

import "./LegoHeader.vue?vue&type=style&index=0&id=7acd27ea&lang=scss"
script.render = render

export default script